var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { quickbooksSync } from '../api/oms/order-history';
import { BuyItAgain } from '../components/purchase-history/buy-it-again/BuyItAgain';
import { CardAndTableView } from '../components/purchase-history/CardAndTableView';
import { MissingPurchase } from '../components/purchase-history/MissingPurchase';
import { OrderViewToggle } from '../components/purchase-history/order-view-toggle/OrderViewToggle';
import { OrderHistoryHeader } from '../components/purchase-history/page-header/OrderHistoryHeader';
import { SortAndSearch } from '../components/purchase-history/sort-and-search/index';
import { PHTableSettingsTile } from '../components/purchase-history/table-view/index';
import AlertBanner from '../components/shared/AlertBanner';
import PageLayout from '../components/shared/PageLayout';
import { SpendingTotals } from '../components/total-perks-spend/SpendingTotals';
import { SpendOverview } from '../components/total-perks-spend/SpendOverview';
import { FeatureSwitches } from '../constants/feature-switches';
import { OrderHistoryModalHooks } from '../hooks/purchase-history-hooks';
import { useCommonContext, useExperienceContext, usePurchaseHistoryContext, } from '../hooks/useContexts';
import { getWindow } from '../utils/general';
import { setPurchaseHistoryPageAnalytics, setQBSyncError, } from '../utils/purchase-history/analytics';
import '../components/purchase-history/table-view/ButtonGroup.scss';
import '../styles/order-history.scss';
// TODO: Remove /* eslint-disable max-lines */ from all files 🚨
/**
 * @param alertState
 * @param qbAlertState
 * @returns Element that holds the alert banners for the purchase history page
 */
var AlertBanners = function (alertState, qbAlertState) { return (React.createElement(React.Fragment, null, qbAlertState && (React.createElement("div", { className: "sui-col-span-1" }, qbAlertState && React.createElement(AlertBanner, __assign({}, qbAlertState)))))); };
export var PurchaseHistory = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _k, _l;
    var customerType = _a.customerType, customerRole = _a.customerRole;
    var _m = useSearchParams(), searchParams = _m[0], setSearchParams = _m[1];
    var _o = useCommonContext(), isMobile = _o.isMobile, isDesktop = _o.isDesktop;
    var _p = usePurchaseHistoryContext(), alertState = _p.alertState, setAlertState = _p.setAlertState, orderHistoryData = _p.orderHistoryData, orderHistoryError = _p.orderHistoryError, orderHistoryLoaded = _p.orderHistoryLoaded, localDeliveryError = _p.localDeliveryError, viewType = _p.viewType, pHRequest = _p.pHRequest;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var crumbs = useAccountCrumbs([
        {
            label: 'Purchase History',
            path: '/myaccount/purchase-history',
        },
    ]);
    // Order History Modal Hooks
    var orderHistoryModalHooks = OrderHistoryModalHooks();
    /** Table Hooks */
    var _q = useState(false), enableSettingsDrawer = _q[0], setEnableSettingsDrawer = _q[1];
    // Alert hook for puchase history page for setting (success, error, or warning) flows
    var _r = useState(null), qbAlertState = _r[0], setQBAlertState = _r[1];
    /**
     * useEffect function that is called on page load only.
     * Set's analytics page level DDO for puchase history on load
     * Checks if there is a quickbooks authCode, realmId, and qbState in the url for online sync
     */
    useEffect(function () {
        setPurchaseHistoryPageAnalytics();
        var authCode = searchParams.get('qb_auth_code');
        var realmId = searchParams.get('qb_realm_id');
        var qbState = searchParams.get('qb_state');
        var qbCancel = searchParams.get('cancel');
        if (authCode && realmId && qbState) {
            var request = {
                quickBooksSyncRequest: {
                    qbState: qbState,
                    qbRealmId: realmId,
                },
            };
            quickbooksSync(request, authCode)
                .then(function () {
                // set successful banner
                setQBAlertState({
                    alertMessage: 'Your Quickbooks account has been successfully synced.',
                    status: 'success',
                    onClose: function () { return setQBAlertState(null); },
                });
            })
                .catch(function (error) {
                // set error banner
                setQBSyncError(error);
                setQBAlertState({
                    alertMessage: 'There was an issue syncing your Quickbooks account, please try again.',
                    status: 'error',
                });
            })
                .finally(function () {
                searchParams.delete('qb_auth_code');
                searchParams.delete('qb_realm_id');
                searchParams.delete('qb_state');
                setSearchParams(searchParams);
            });
        }
        if (qbCancel) {
            searchParams.delete('cancel');
            setSearchParams(searchParams);
        }
    }, []);
    var poUpdatedOrderHistory = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.getItem('purchaseHistory-poJobUpdate')) || null;
    /**
     * TBD - ? what is this for
     */
    if ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) && poUpdatedOrderHistory) {
        var parsedPOUpdatedOrderHistory = JSON.parse(poUpdatedOrderHistory);
        for (var i = 0; i < (parsedPOUpdatedOrderHistory === null || parsedPOUpdatedOrderHistory === void 0 ? void 0 : parsedPOUpdatedOrderHistory.length); i += 1) {
            for (var _j = 0; _j < orderHistoryData.orders.length; _j += 1) {
                if (((_d = (_c = parsedPOUpdatedOrderHistory === null || parsedPOUpdatedOrderHistory === void 0 ? void 0 : parsedPOUpdatedOrderHistory[i]) === null || _c === void 0 ? void 0 : _c.orderNumbers) === null || _d === void 0 ? void 0 : _d[0]) ===
                    ((_g = (_f = (_e = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _e === void 0 ? void 0 : _e[_j]) === null || _f === void 0 ? void 0 : _f.orderNumbers) === null || _g === void 0 ? void 0 : _g[0]) &&
                    ((_h = parsedPOUpdatedOrderHistory === null || parsedPOUpdatedOrderHistory === void 0 ? void 0 : parsedPOUpdatedOrderHistory[i]) === null || _h === void 0 ? void 0 : _h.totalAmount) ===
                        ((_l = (_k = orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orders) === null || _k === void 0 ? void 0 : _k[_j]) === null || _l === void 0 ? void 0 : _l.totalAmount)) {
                    orderHistoryData.orders[_j] = parsedPOUpdatedOrderHistory[i];
                }
            }
        }
    }
    /**
     * Effect hook that sets order history data to session storage
     */
    useEffect(function () {
        var _a;
        if (orderHistoryData) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('orderHistory', JSON.stringify(orderHistoryData));
        }
    }, [orderHistoryLoaded, orderHistoryData]);
    useEffect(function () {
        var _a;
        if (((_a = orderHistoryError === null || orderHistoryError === void 0 ? void 0 : orderHistoryError.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: "We're sorry, there is a technical error. Please try again later.",
                status: 'error',
            });
            return;
        }
        if (orderHistoryError) {
            setAlertState({
                alertTitle: 'Purchase History Unavailable',
                alertMessage: 'Something went wrong on our end. Please check back later',
                status: 'error',
            });
        }
    }, [orderHistoryError]);
    var searchEnabled = pHRequest.searchBy !== undefined;
    var showSpendingTotal = orderHistoryLoaded &&
        customerType === 'b2b' &&
        (orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.customerAccountId);
    return (React.createElement(PageLayout, { crumbs: crumbs, customerRole: customerRole, customerType: customerType, headerComponent: React.createElement(OrderHistoryHeader, null), internalRoutes: ['/myaccount/order-history'], isMobile: isMobile, pageTitle: "Purchase History" },
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 md:sui-gap-6" },
            !FeatureSwitches.enableNewLoyaltySpendUI && showSpendingTotal && (React.createElement("div", { className: "md:sui-flex sui-justify-end sui-hidden" },
                React.createElement(ErrorBoundary, { name: "total-spend" },
                    React.createElement(SpendingTotals, null)))),
            ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount) || 0) > 1 && customerType === 'b2b' && (React.createElement("div", { className: "sui-col-span-1  ".concat(isDesktop && FeatureSwitches.enableNewLoyaltySpendUI
                    ? 'lg:sui-flex lg:sui-gap-[31px]'
                    : '', " ").concat(isConsumerApp ? '' : 'sui-mb-[24px] md:sui-mb-0') },
                React.createElement(ErrorBoundary, { name: "buy-it-again" },
                    React.createElement(BuyItAgain, null)),
                isDesktop && FeatureSwitches.enableNewLoyaltySpendUI && (React.createElement(ErrorBoundary, { name: "spend-overview" },
                    React.createElement(SpendOverview, null))))),
            viewType !== 'LocalDeliveries' ? (React.createElement("div", { className: "no-print sui-col-span-1" },
                React.createElement("div", { className: "sui-flex sui-flex-row" },
                    React.createElement(ErrorBoundary, { name: "sort-and-search" },
                        React.createElement(SortAndSearch, { orderCount: orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.orderCount })),
                    customerType === 'b2c' && (React.createElement("div", { className: "sui-hidden md:sui-flex md:sui-self-center md:sui-pt-6" },
                        React.createElement(MissingPurchase, null)))))) : (React.createElement("div", null)),
            React.createElement("div", { className: "no-print sui-hidden md:sui-flex md:sui-items-center lg:sui-flex lg:sui-items-center sui-col-span-1 sui-justify-between" },
                React.createElement("div", { className: "sui-w-full sui-flex sui-justify-between" }, customerType !== 'b2c' && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "sui-flex sui-items-center" },
                        React.createElement(ErrorBoundary, { name: "order-view-toggle" },
                            React.createElement(QueryProvider, { cacheKey: "loyalty-benefits-cacheKey" },
                                React.createElement(OrderViewToggle, null))),
                        React.createElement(MissingPurchase, null)),
                    FeatureSwitches.enableTableSettings &&
                        viewType === 'Table' &&
                        !searchEnabled && (React.createElement(ErrorBoundary, { name: "table-customization" },
                        React.createElement(PHTableSettingsTile, { setEnableSettingsDrawer: setEnableSettingsDrawer }))))))),
            AlertBanners(alertState, qbAlertState),
            React.createElement("div", { className: "sui-col-span-1 sui-max-w-[1039px]" },
                React.createElement(CardAndTableView, { orderHistoryModalHooks: orderHistoryModalHooks, enableSettingsDrawer: enableSettingsDrawer, setEnableSettingsDrawer: setEnableSettingsDrawer })),
            orderHistoryModalHooks.orderHistoryModalComponent)));
};
PurchaseHistory.displayName = 'Purchase History';
